import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, TextField, InputAdornment, IconButton } from '@mui/material';
import { Send } from '@mui/icons-material';
import { Formik } from 'formik';

type InputProps = {
    onSend: (message: string) => void;
    inProgress?: boolean;
    countMessages: number;
};

export const Input = memo((props: InputProps) => {
    const { t } = useTranslation();

    return props.countMessages === 0 ? (
        <Formik
            initialValues={{ userInput: '' }}
            onSubmit={(values) => {
                props.onSend(values.userInput);
            }}
        >
            {({ values, handleChange, handleSubmit, isSubmitting }) => (
                <Stack
                    direction="row"
                    gap={2}
                    px={3}
                    mb={2}
                    sx={{ justifyContent: 'left', flexWrap: 'wrap', maxWidth: '100%' }}
                    mt={5}
                >
                    <TextField
                        name="userInput"
                        type="text"
                        value={values.userInput}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                if (values.userInput && !isSubmitting) {
                                    handleSubmit();
                                }
                            }
                        }}
                        fullWidth
                        variant="outlined"
                        label={t('onboarding.input.label.write-about-business')}
                        required
                        slotProps={{
                            input: {
                                sx: { pr: 1 },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            sx={{
                                                bgcolor: 'primary.main',
                                                color: 'primary.contrastText',
                                                borderRadius: 2,
                                                '&:hover': { bgcolor: 'primary.dark' },
                                            }}
                                            disabled={!values.userInput || isSubmitting}
                                            onClick={() => handleSubmit()}
                                        >
                                            <Send />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            },
                        }}
                    />
                </Stack>
            )}
        </Formik>
    ) : null;
});
